import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';
import { httpErrorMessage } from '../../../core/utils/http-error-message';

@Component({
  selector: 'app-forgot-password',
  imports: [FormsModule, RouterLink],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
})
export class ForgotPassword {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  email = this.route.snapshot.queryParamMap.get('email') ?? '';
  readonly portal = this.resolvePortal(this.route.snapshot.queryParamMap.get('portal'));
  isSubmitting = false;
  errorMessage = '';
  successMessage = '';

  onSubmit(): void {
    const normalizedEmail = this.email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      this.errorMessage = 'Enter a valid email address.';
      this.successMessage = '';
      this.isSubmitting = false;
      return;
    }

    this.email = normalizedEmail;
    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.auth.forgotPassword({
      email: normalizedEmail,
      accountType: this.portal === 'admin' ? 'Platform' : 'Business',
    }).pipe(finalize(() => {
      this.isSubmitting = false;
    })).subscribe({
      next: (response) => {
        this.successMessage = response.message || 'OTP sent to your registered email.';
        void this.router.navigate(['/reset-password'], {
          queryParams: { email: normalizedEmail, portal: this.portal, sent: 1 },
        });
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = httpErrorMessage(error, 'Unable to send password reset OTP.');
      },
    });
  }

  get loginRoute(): string {
    return this.portal === 'admin' ? '/admin-login' : this.portal === 'franchise' ? '/franchise-login' : '/login';
  }

  private resolvePortal(value: string | null): 'admin' | 'business' | 'franchise' {
    return value === 'admin' || value === 'franchise' ? value : 'business';
  }
}
